import { UPDATE_USER_INFO_SUCCESS } from '@/constants';

import * as constants from './Mobile.constants';
import * as services from './Mobile.service';
//import { cookieGetItem, cookieSetItemInfinity } from '../../global/cookie';

const state = {
  regionNo: [],
  isMobileRequest: false,
  isMobileCheckExistRequest: false,
};

const mutations = {
  [constants.GET_REGION_NO_SUCCESS](state, regionNo) {
    state.regionNo = regionNo;
  },

  [constants.DUMMY_MUTATION]() { },

  [constants.SET_IS_MOBILE_REQUEST_STATUS](state, status) {
    state.isMobileRequest = status;
  },

  [constants.SET_IS_MOBILE_CHECK_EXIST_REQUEST_STATUS](state, status) {
    state.isMobileCheckExistRequest = status;
  },
};

const actions = {
  async getRegionNo({ commit }, payload) {
    commit(constants.SET_IS_MOBILE_REQUEST_STATUS, true);
    const res = await services.getRegionNo(payload);

    commit(constants.GET_REGION_NO_SUCCESS, res.data.data);
    commit(constants.SET_IS_MOBILE_REQUEST_STATUS, false);
  },

  async checkExistMobile({ commit }, payload) {
    commit(constants.SET_IS_MOBILE_CHECK_EXIST_REQUEST_STATUS, true);
    const res = await services.checkExistMobile(payload);
    commit(constants.DUMMY_MUTATION, res.data.data);
    commit(constants.SET_IS_MOBILE_CHECK_EXIST_REQUEST_STATUS, false);
    return res;
  },

  async getMobileCode({ commit }, payload) {
    const res = await services.getMobileCode(payload);
    commit(constants.DUMMY_MUTATION, res.data.data);
    return res;
  },

  async getMobileCodeLogin({ commit }, payload) {
    const res = await services.getMobileCodeLogin(payload);
    commit(constants.DUMMY_MUTATION, res.data.data);
    return res;
  },

  async getMobileCodeLoginWithoutMobile({ commit }, payload) {
    const res = await services.getMobileCodeLoginWithoutMobile(payload);
    commit(constants.DUMMY_MUTATION, res.data.data);
    return res;
  },

  async getMobileCodeLoginUniqueGlobal({ commit }, payload) {
    const res = await services.getMobileCodeLoginUniqueGlobal(payload);
    commit(constants.DUMMY_MUTATION, res.data.data);
    return res;
  },

  async updateMobile({ commit }, payload) {
    const params = services.updateMobile(payload);
    const res = await params;
    if (res.data.data) {
      commit(
        UPDATE_USER_INFO_SUCCESS,
        {
          mobile: payload.mobile,
        },
        { root: true }
      );
    }
    return params;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
